module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Gb-Ha-Ia-outside.f8cad7de.png";